import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import Select from '@atlaskit/select/default';
import type { ValueType } from '@atlaskit/select/types';

import { messages } from '../../common/messages';
import {
	type ContentOptionValue,
	getSelectedOption,
	type SelectOption,
} from './config-panel-options';
import { FieldLabel } from './config-panel-primitives';

const goalSelectStyles = cssMap({
	root: {
		position: 'relative',
		zIndex: 100,
	},
});

type GoalSelectProps = {
	contentSelection: ContentOptionValue;
	isDisabled?: boolean;
	onContentSelectionChange: (contentSelection: ContentOptionValue) => void;
	options: SelectOption<ContentOptionValue>[];
};

export const GoalSelect = ({
	contentSelection,
	isDisabled = false,
	onContentSelectionChange,
	options,
}: GoalSelectProps): JSX.Element => {
	const intl = useIntl();

	return (
		<Box xcss={goalSelectStyles.root}>
			<FieldLabel htmlFor="agent-managed-extension-goal">
				{intl.formatMessage(messages.contentGoalLabel)}
			</FieldLabel>
			<Select<SelectOption<ContentOptionValue>>
				inputId="agent-managed-extension-goal"
				options={options}
				value={getSelectedOption(options, contentSelection)}
				onChange={(option: ValueType<SelectOption<ContentOptionValue>>) => {
					if (option) {
						onContentSelectionChange(option.value);
					}
				}}
				isDisabled={isDisabled}
				isSearchable={false}
			/>
		</Box>
	);
};
